import { Injectable } from '@angular/core';
import { HotjarAnalyticsTrackingData } from '../models/tracking-data.model';
import { TrackingProviders } from '../models/tracking-providers.enum';
import { HotjarAnalyticsTrackingTag } from '../models/tracking-tag.model';
import { AbstractTrackingMapperService } from './abstract-tracking-mapper.service';

@Injectable()
export class HotjarAnalyticsMapperService implements AbstractTrackingMapperService<HotjarAnalyticsTrackingTag, HotjarAnalyticsTrackingData> {
  getTrackingProviderName(): TrackingProviders {
    return TrackingProviders.HotjarAnalytics;
  }

  getTrackingDataForProvider(trackingTag: HotjarAnalyticsTrackingTag /* trackingData: TrackingData */): HotjarAnalyticsTrackingData {
    const params: Partial<HotjarAnalyticsTrackingData> = {};
    params.event_name = trackingTag?.pageName;
    return params as HotjarAnalyticsTrackingData;
  }
}
